import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Subscription } from "rxjs";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { Company } from "src/app/models/Company";
import { Tool } from "src/app/models/Tool";
import { CompanyService } from "src/app/services/company.service";

import { FieldServiceService } from "./../../services/field-service.service";

@Component({
  selector: "app-field-service-tools",
  templateUrl: "./field-service-tools.component.html",
  styleUrls: ["./field-service-tools.component.scss"],
  standalone: false,
})
export class FieldServiceToolsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  readonly routeNameConstants = RouteNameConstants;
  readonly localizationConstants = LocalizationConstants;
  faSpinner = faSpinner;
  subscription: Subscription;
  company: Company;
  dataSource = new MatTableDataSource<Tool>([]);
  companyId: string;
  jobNumber: string;
  status: string; // planned or last job, need to fetch correct details
  pageSize: number = 10;
  isLoading: boolean;

  columns = [
    // Intentionally exchanged toolId with serialNumber
    { key: "serialNumber", title: LocalizationConstants.TOOL_TOOL_ID },
    { key: "toolId", title: LocalizationConstants.TOOL_SERIAL_NUMBER },
    { key: "modelNumber", title: LocalizationConstants.TOOL_MODEL_NUMBER },
    { key: "articleNumber", title: LocalizationConstants.TOOL_ARTICLE_NUMBER },
    { key: "description", title: LocalizationConstants.TOOL_DESCRIPTION },
  ];

  columnKeys = this.columns.map((column) => column.key);

  constructor(
    public fsService: FieldServiceService,
    private companyService: CompanyService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.companyId = this.route.parent.snapshot.paramMap.get("companyId");
    this.jobNumber = this.route.parent.snapshot.paramMap.get("jobNumber");
    this.status = this.route.parent.snapshot.paramMap.get("status");
    this.company = this.companyService.selectedCompany;

    if (!this.company?.name || this.company.name != this.companyId) return;
    this.getFsJobDetails();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  getFsJobDetails() {
    this.isLoading = true;
    this.fsService.get(this.companyId, this.jobNumber).subscribe(
      (response) => {
        this.isLoading = false;
        if (!response) {
          return;
        }
        this.dataSource.data = response?.tools || [];
      },
      () => (this.isLoading = false),
    );
  }
}
